import { render } from "./DispensarVistoria.vue?vue&type=template&id=74fe89b5"
import script from "./DispensarVistoria.vue?vue&type=script&lang=js"
export * from "./DispensarVistoria.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__